import service from '@/utils/server';

const modName='/bd/orderSearch/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/toBOrder/order/api/index.js